export type CpUserStatus = 'ACTIVE' | 'INACTIVE';

export interface CpTeamUser {
  id: string;
  coreUserId: string;
  firstName: string;
  lastName: string;
  fullName: string;
  email: string;
  phone: string;
  roleId: string | null;
  roleName: string;
  departmentId: string | null;
  departmentName: string;
  reportsToName: string;
  status: CpUserStatus;
  selected?: boolean;
}

export interface CpUserListFilters {
  search: string;
  status: '' | CpUserStatus;
}

export interface CpUserState {
  users: CpTeamUser[];
  loading: boolean;
  error: string | null;
  filters: CpUserListFilters;
  lastLoadedAt: number | null;
}

export const initialCpUserState: CpUserState = {
  users: [],
  loading: false,
  error: null,
  filters: { search: '', status: '' },
  lastLoadedAt: null,
};
